import styles from "../styles/GetAppLanding.module.scss";
import appleIcon from "../assets/footer-apple-icon.svg";
import arrowRight from "../assets/footer-arrow-right.svg";
import aboundWordmark from "../assets/footer-abound-wordmark.svg";
import facebookIcon from "../assets/footer-facebook-icon.svg";
import instagramIcon from "../assets/footer-instagram-icon.svg";
import playIcon from "../assets/footer-play-icon.svg";
import storeDivider from "../assets/footer-store-divider.svg";
import toiLogo from "../assets/footer-toi-logo.png";
import xIcon from "../assets/footer-x-icon.svg";

const socialLinks = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/joinabound/",
    icon: facebookIcon,
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/joinabound/",
    icon: instagramIcon,
  },
  {
    label: "X",
    href: "https://x.com/joinabound",
    icon: xIcon,
  },
];

const Footer = () => {
  return (
    <footer className={styles.footer} id="company">
      <div className={styles.footerTop}>
        <div className={styles.footerInitiative}>
          <img src={aboundWordmark} alt="Abound" />
          <span>a trusted initiative by</span>
        </div>
        <img
          className={styles.footerToiLogo}
          src={toiLogo}
          alt="The Times of India"
        />
      </div>
      <div className={styles.footerLinks}>
        {/* <div>
          <h3>Company</h3>
          <a href="/getapp/getApp">About</a>
          <a href="#company">FAQ</a>
          <a href="/blog">Blog</a>
        </div> */}
        <div>
          <h3>Abound Products</h3>
          <a href="#send-money">Send Money</a>
          <a href="#cashback">Rewards</a>
          <a href="#earn-interest">Abound Earn</a>
        </div>
        <div>
          <h3>Legal</h3>
          <a href="https://accounts.joinabound.com/privacy" target="_blank">
            Privacy Policy
          </a>
          <a href="https://accounts.joinabound.com/legal" target="_blank">
            Terms & Conditions
          </a>
          {/* <a href="/financialnotice.html">Synapse Disclosure</a> */}
        </div>
        <div>
          <h3>Contact Us</h3>
          <p>
            <span className={styles.mails}>{`Customer Care: `}</span>
            <span className={styles.emailAction}>
              <a href="mailto:support@joinabound.com">support@joinabound.com</a>
            </span>
          </p>
          <p>
            <span className={styles.mails}>{`Partnerships: `}</span>
            <span className={styles.emailAction}>
              <a href="mailto:partnerships@joinabound.com">
                partnerships@joinabound.com
              </a>
            </span>
          </p>
        </div>
        <div className={styles.footerActions}>
          <a href="https://accounts.joinabound.com/getapp/signup/v2?source=remittance">
            <span>Sign in</span>
            <img src={arrowRight} alt="" />
          </a>
          <a href="https://timesclub.app.link/remittancetab" target="_blank">
            <span className={styles.storeIcons}>
              <img src={appleIcon} alt="" />
              <img src={storeDivider} alt="" />
              <img src={playIcon} alt="" />
            </span>
            <span>Download app</span>
          </a>
        </div>
      </div>
      <div className={styles.footerBottom}>
        <div className={styles.footerCopyright}>
          <span>
            &copy;{`TClub Inc ${new Date().getFullYear()} All rights reserved`}
          </span>
          {/* <a href="/sitemap.xml">Sitemap</a> */}
        </div>
        <div className={styles.socialLinks} aria-label="Social links">
          {socialLinks.map((item) => (
            <a
              key={item.label}
              href={item.href}
              target="_blank"
              rel="noreferrer"
              aria-label={item.label}
            >
              <img src={item.icon} alt="" aria-hidden="true" />
            </a>
          ))}
        </div>
      </div>
      
    </footer>
  );
};

export default Footer;
